import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { ICase } from '../../interfaces/case.interface';
import { CasesService } from '../../../../core/services/cases.service';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { ICaseFile } from '../../interfaces/case-file.interface';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { ActivatedRoute } from '@angular/router';

enum texts {
  title = 'Crear caso',
  editTitle = 'Editar caso',
  create = 'Crear',
  edit = 'Editar',
}

@Component({
  selector: 'app-create-case',
  templateUrl: './create-case.component.html',
  styleUrls: ['./create-case.component.scss'],
})
export class CreateCaseComponent implements OnInit {
  public Texts = texts;
  additionalFormValid: boolean = true;
  aditionalInfoForm: any = null;
  caseId: string = null;
  createCase: boolean = false;
  unit: IUnit;
  constructor(
    private readonly casesService: CasesService,
    public readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly unitsService: UnitsService,
    private readonly dialogRef: MatDialogRef<CreateCaseComponent>,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      unit: string;

      case?: ICase;
    }
  ) {
    this.getUnit(this.data.unit);
  }

  form = this.fb.group({
    caseType: ['', [Validators.required]],
    assigned: ['', [Validators.required]],
    description: ['', [Validators.required]],
  });

  get caseType() {
    if (this.isEditing) {
      return this.data.case.caseType._id;
    } else {
      return this.form.get('caseType').value;
    }
  }

  get isEditing() {
    return !!this.data?.case;
  }

  caseTypes: ICaseType[] = [];

  ngOnInit() {
    this.getCaseTypes();
    if (this.isEditing) {
      const caseEdit = this.data.case;

      let data = {
        caseType: caseEdit.caseType._id,
        assigned: caseEdit.assigned?._id || null,
        description: caseEdit.description,
      };
      this.form.patchValue(data);

      this.form.get('caseType').disable();
      this.casesService.getFiles(caseEdit._id).subscribe({
        next: (files) => {
          this.files = files;
        },
      });
    }
  }

  async findUser() {
    let caseType = this.caseTypes.find((item) => item._id == this.caseType);

    const roles = caseType.role;
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    this.users = users;
  }

  users: IUser[] = [];

  getCaseTypes() {
    this.unitsService.getTypeCases(this.data.unit).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        if (this.caseType) {
          this.findUser();
        }
      },
    });
  }

  files: ICaseFile[] = [];
  newFiles: ICaseFile[] = [];
  deleteFiles: ICaseFile[] = [];

  closeModal() {
    this.dialogRef.close();
  }

  save() {
    if (this.isEditing) {
      this.edit();
    } else {
      this.create();
    }
  }

  edit() {
    this.isLoading = true;

    const data = this.form.value;

    data.caseType = this.data.case.caseType._id;
    data.newFiles = this.newFiles;
    data.deleteFiles = this.deleteFiles;
    data.additionalInformation = this.aditionalInfoForm;
    if (data.status != this.data.case.status) {
      switch (data.status) {
        case 'initial':
          data.initialAt = new Date();
          break;
        case 'running':
          data.runningAt = new Date();
          break;
        case 'tobeApproved':
          data.tobeApprovedAt = new Date();

          break;
        case 'toFinalize':
          data.toFinalizeAt = new Date();
          break;
        default:
          break;
      }
    }

    data.user_changing = this.userService.currentUser._id;

    this.casesService.update(this.data.case._id, data).subscribe({
      next: (caseUpdated: any) => {
        // this.casesService
        //   .saveAuditory('EditCase', caseUpdated)
        //   .subscribe((res) => console.log(' '));
        this.isLoading = false;
        this.alert('Caso editado con éxito');
        this.caseId = caseUpdated._id;
        this.createCase = true;

        caseUpdated.additionalInformation = this.aditionalInfoForm;
        if (typeof caseUpdated.caseType.unit == 'object') {
          // caseUpdated.caseType.unit = caseUpdated.caseType.unit._id;
        }

        this.dialogRef.close(caseUpdated);
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  isLoading = false;

  alert(title: string) {
    this.dialog.open(SuccessComponent, {
      data: { title },
    });
  }

  additionalFormValidChange(info: any) {
    this.additionalFormValid = info.val;
    this.aditionalInfoForm = info.additionalInformation;
  }

  create() {
    this.isLoading = true;
    const data = this.form.value;
    // TODO ARREGLAR ESTE BUG DE ARCHIVOS EN CASOS
    data.files = this.files;
    // data.files = [];
    data.additionalInformation = this.aditionalInfoForm;
    this.casesService.create(data).subscribe({
      next: (caseCreated: any) => {
        // this.casesService
        //   .saveAuditory('CreateCase', caseCreated)
        //   .subscribe((res) => console.log(''));
        this.isLoading = false;
        this.alert('Caso creado con éxito!');
        this.caseId = caseCreated._id;
        this.createCase = true;
        caseCreated.additionalInformation = this.aditionalInfoForm;
        if (typeof caseCreated.caseType.unit == 'object') {
          caseCreated.caseType.unit = caseCreated.caseType.unit._id;
        }

        if (
          (this.userService.currentUser.role.createCases &&
            this.userService.currentUser.role.editCases) ||
          caseCreated.assigned._id == this.userService.currentUser._id
        ) {
          this.casesService.caseCreated.next(caseCreated);
        }
        this.dialogRef.close();
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  //Obtener la unidad en la que se encuentra
  async getUnit(id) {
    await this.unitsService.getById(id).subscribe((res) => {
      this.unit = res;
    });
  }
}
